export default __webpack_public_path__ + "static/media/placeholder-news-home-260x128.6cdf95e1.svg";